<template>
    <div class="w-auto">
        <dropdown
            ref="changePermissionLevelDropdown"
            open-from="right"
            :px-width="440"
            :enabled="
                admin.permission_level_id !== 1 &&
                $page.props.auth.user.group_admin_permission_level !=
                    'read-only'
            "
        >
            <template #button>
                <div
                    :class="
                        'w-auto rounded border border-gray-450 p-2' +
                        ' ' +
                        (admin.permission_level_id === 1 ||
                        $page.props.auth.user.group_admin_permission_level ===
                            'read-only'
                            ? 'bg-gray-250 hover:cursor-not-allowed'
                            : 'hover:cursor-pointer')
                    "
                >
                    <span v-if="admin.permission_level_id === 1">Owner</span>
                    <span v-if="admin.permission_level_id === 2"
                        >Full Admin</span
                    >
                    <span v-if="admin.permission_level_id === 3"
                        >Read-only Admin</span
                    >
                </div>
            </template>
            <template #content>
                <ul class="rounded border p-1 text-[15px]">
                    <li
                        v-if="
                            $page.props.auth.user
                                .group_admin_permission_level === 'owner'
                        "
                        @click="updateAdminPermission(1)"
                        class="group flex-col gap-3 rounded p-3 hover:cursor-pointer hover:bg-primary-500 hover:text-white"
                    >
                        <div class="pb-1 font-semibold">Owner</div>
                        <div class="text-gray-750 group-hover:text-white">
                            Can invite new admins and students, create and
                            manage classrooms and can view organization-wide
                            payment history. Only 1 owner allowed per
                            organization.
                        </div>
                    </li>
                    <li
                        @click="updateAdminPermission(2)"
                        class="group flex-col gap-3 rounded p-3 hover:cursor-pointer hover:bg-primary-500 hover:text-white"
                    >
                        <div class="pb-1 font-semibold">Full Admin</div>
                        <div class="text-gray-750 group-hover:text-white">
                            Can invite and manage students and create/manage
                            classrooms.
                        </div>
                    </li>
                    <li
                        @click="updateAdminPermission(3)"
                        class="group flex-col gap-3 rounded p-3 hover:cursor-pointer hover:bg-primary-500 hover:text-white"
                    >
                        <div class="pb-1 font-semibold">Read-only Admin</div>
                        <div class="text-gray-750 group-hover:text-white">
                            Can see everything but can’t take any actions.
                        </div>
                    </li>
                </ul>
            </template>
        </dropdown>
    </div>

    <new-modal
        title="Transfer Ownership?"
        ref="transferOwnershipModal"
        size="2xl"
    >
        <template #content>
            <div class="flex flex-col gap-4">
                <div class="">
                    If you assign
                    <span class="font-semibold">{{ newOwnerName }}</span> as an
                    owner, you will be downgraded to a “Full Admin” since there
                    can only be 1 owner per organization.
                </div>
                <div class="">Are you sure you’d like to do this?</div>
                <div class="mt-4 flex flex-row justify-end gap-4">
                    <span
                        class="btn btn-outline"
                        @click="cancelTransferOwnership()"
                        >Cancel</span
                    >
                    <span class="btn btn-danger" @click="transferOwnership()"
                        >Yes, transfer ownership</span
                    >
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import Dropdown from "@/Components/Dropdown";
import NewModal from "@/Components/NewModal";

export default {
    name: "GroupAdminPermissionSelectAndChange",
    components: {
        Dropdown,
        NewModal,
    },
    props: {
        admin: {
            type: Object,
            default: {},
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            permissionOptions: [
                { id: 1, name: "Owner", canChoose: false },
                { id: 2, name: "Full Admin", canChoose: true },
                { id: 3, name: "Read Only", canChoose: true },
            ],
            form: this.$inertia.form({
                adminId: this.admin.id,
                permissionLevelId: this.admin.permission_level_id,
            }),
            showTransferOwnershipModal: false,
            newOwnerName: "",
        };
    },
    methods: {
        updateAdminPermission(permissionLevel) {
            let vm = this;

            if (permissionLevel === 1) {
                vm.newOwnerName = vm.admin.full_name;
                vm.$refs.transferOwnershipModal.openModal();
            } else {
                vm.form.permissionLevelId = permissionLevel;

                vm.$inertia.get(
                    route("group.admin.update-permissions", vm.form, {
                        onSuccess: function () {
                            vm.$refs.changePermissionLevelDropdown.closeDropdown();
                        },
                    })
                );
            }
        },
        transferOwnership() {
            let vm = this;

            vm.form.permissionLevelId = 1;

            vm.$inertia.get(
                route("group.admin.update-permissions", vm.form, {
                    preserveState: false,
                    onSuccess: function () {
                        vm.$refs.changePermissionLevelDropdown.closeDropdown();
                        vm.$refs.transferOwnershipModal.closeModal();
                    },
                })
            );
        },
        cancelTransferOwnership() {
            this.$refs.changePermissionLevelDropdown.closeDropdown();
            this.$refs.transferOwnershipModal.closeModal();
        },
    },
};
</script>
